import { useEffect, useState } from 'react';
import { supabase } from '@core/supabase/client';

/**
 * Signed URL for private Supabase Storage objects (works in <img src>).
 * Regenerates when `path` changes; default TTL 12h.
 */
export function useSignedStorageObjectUrl(
  bucket: string,
  path: string | null | undefined,
  expiresInSec = 60 * 60 * 12,
): { url: string | null; loading: boolean; error: boolean } {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!path?.trim()) {
      setUrl(null);
      setLoading(false);
      setError(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);

    void (async () => {
      const { data, error: err } = await supabase.storage.from(bucket).createSignedUrl(path.trim(), expiresInSec);
      if (cancelled) return;
      if (err || !data?.signedUrl) {
        setUrl(null);
        setError(true);
      } else {
        setUrl(data.signedUrl);
        setError(false);
      }
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [bucket, path, expiresInSec]);

  return { url, loading, error };
}
